import { render, staticRenderFns } from "./inputPrice.vue?vue&type=template&id=17065e1b&scoped=true&"
import script from "./inputPrice.vue?vue&type=script&lang=js&"
export * from "./inputPrice.vue?vue&type=script&lang=js&"
import style0 from "./inputPrice.vue?vue&type=style&index=0&id=17065e1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17065e1b",
  null
  
)

export default component.exports